module.exports = __webpack_public_path__ + "static/media/litho-2.4214d8e9.jpg";